<div class="content questions-page">
  <div class="container-fluid questions-container">
    <header class="questions-page-header">
      <div>
        <h1 class="dashboard-title mb-1">Questions</h1>
        <p class="questions-subtitle mb-0">Manage category questions and procedure codes separately for Dental and Medical.</p>
      </div>
      <button *ngIf="authService.hasRole('client-edit')" class="btn btn-primary questions-add-button" type="button"
              routerLink="add" [queryParams]="{ domain: selectedDomain }">
        <mat-icon>add</mat-icon><span>Add Questions</span>
      </button>
    </header>

    <section class="questions-panel" aria-label="Question management">
      <div class="questions-toolbar">
        <div class="questions-search">
          <mat-icon aria-hidden="true">search</mat-icon>
          <input #searchBox type="search" placeholder="Search questions or procedure codes..."
                 aria-label="Search questions or procedure codes"
                 (keyup)="handleKeyUp($event)">
          <button *ngIf="searchBox.value" class="questions-clear" type="button"
                  (click)="clearSearch(searchBox)" aria-label="Clear search">
            <mat-icon>close</mat-icon>
          </button>
          <button class="btn btn-primary questions-search-submit" type="button" (click)="onSearch()">
            Search
          </button>
        </div>

        <div class="questions-filters">
          <mat-form-field appearance="outline" class="questions-domain-field">
            <mat-label>Domain</mat-label>
            <mat-select [value]="selectedDomain" (selectionChange)="changeDomain($event.value)">
              <mat-option value="DENTAL">Dental</mat-option>
              <mat-option value="MEDICAL">Medical</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="questions-category-field">
            <mat-label>Category</mat-label>
            <mat-select [(ngModel)]="selectedCategory" (selectionChange)="changeCategory($event)">
              <mat-option *ngFor="let option of categoryArray" [value]="option.category">
                {{ option.category }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="questions-table-scroll">
        <table class="questions-table" matSort (matSortChange)="sortData($event)">
          <thead>
            <tr>
              <th scope="col" class="questions-number-col">Sr. No.</th>
              <th scope="col" mat-sort-header="categoryName">Category</th>
              <th scope="col" mat-sort-header="question">Question</th>
              <th scope="col" mat-sort-header="questionCode">Procedure Code</th>
              <th scope="col">Severity</th>
              <th scope="col" class="questions-actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let table of tableData | filter: searchText; let i = index">
              <td class="questions-index">{{ i + 1 }}</td>
              <td class="questions-category-value">{{ table?.category || '-' }}</td>
              <td class="questions-text-value">{{ table?.question || '-' }}</td>
              <td><span class="questions-code" *ngIf="table?.questionCode; else noCode">{{ table.questionCode }}</span>
                <ng-template #noCode><span class="text-muted">-</span></ng-template>
              </td>
              <td><span class="badge" [class.badge-danger]="table?.severity?.toUpperCase() === 'CRITICAL'"
                       [class.badge-secondary]="table?.severity?.toUpperCase() !== 'CRITICAL'">{{table?.severity || 'Not configured'}}</span></td>
              <td class="questions-actions">
                <a *ngIf="authService.hasRole('client-edit')" class="question-icon-button"
                   title="Edit question" aria-label="Edit question"
                   [routerLink]="['details/', table.id]" [queryParams]="{ domain: selectedDomain }">
                  <mat-icon>edit</mat-icon>
                </a>
                <button *ngIf="authService.hasRole('client-edit')" type="button"
                        class="question-icon-button question-icon-danger"
                        [attr.aria-label]="'Delete ' + table.question" title="Delete question"
                        (click)="deleteEntry(table.id, table.question)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </tr>
            <tr *ngIf="!tableData || !tableData.length">
              <td colspan="6" class="questions-empty">
                <mat-icon>playlist_add_check</mat-icon>
                <strong>No questions found</strong>
                <span>Try another category, search, or domain.</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</div>
